(() => {
  if (customElements.get('milwaukee-hero')) return;
  customElements.define('milwaukee-hero', class extends HTMLElement {
    connectedCallback() {
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.slides = [...this.querySelectorAll('.mw-hero__slide')];
      this.dots = [...this.querySelectorAll('[data-slide]')];
      this.pause = this.querySelector('.mw-hero__pause');
      this.index = 0;
      this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.reducedMotion.matches;
      this.hovered = false;
      this.addEventListener('click', event => {
        const direction = event.target.closest('[data-direction]');
        const dot = event.target.closest('[data-slide]');
        if (direction || dot) {
          this.paused = true;
          this.show(direction ? this.index + Number(direction.dataset.direction) : Number(dot.dataset.slide), true);
        }
        if (event.target.closest('.mw-hero__pause')) { this.paused = !this.paused; this.schedule(); }
      }, options);
      this.addEventListener('mouseenter', () => { this.hovered = true; this.schedule(); }, options);
      this.addEventListener('mouseleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.paused = true; this.schedule(); }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.reducedMotion.addEventListener('change', () => { if (this.reducedMotion.matches) this.paused = true; this.schedule(); }, options);
      this.addEventListener('touchstart', event => {
        this.touch = { x: event.changedTouches[0].clientX, y: event.changedTouches[0].clientY };
      }, { ...options, passive: true });
      this.addEventListener('touchend', event => {
        if (!this.touch) return;
        const dx = event.changedTouches[0].clientX - this.touch.x;
        const dy = event.changedTouches[0].clientY - this.touch.y;
        if (Math.abs(dx) > 55 && Math.abs(dx) > Math.abs(dy)) { this.paused = true; this.show(this.index + (dx < 0 ? 1 : -1), true); }
        this.touch = null;
      }, { ...options, passive: true });
      document.addEventListener('shopify:block:select', event => {
        const index = this.slides.findIndex(slide => slide.dataset.blockId === event.detail.blockId);
        if (index >= 0) { this.paused = true; this.show(index); }
      }, options);
      this.schedule();
    }
    show(index, announce = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; });
      this.dots.forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
      if (announce) this.querySelector('[data-slide-status]').textContent = `Slide ${this.index + 1} van ${this.slides.length}`;
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.pause) {
        this.pause.setAttribute('aria-pressed', String(this.paused));
        this.pause.setAttribute('aria-label', this.paused ? 'Slideshow afspelen' : 'Slideshow pauzeren');
        this.pause.firstElementChild.textContent = this.paused ? '▶' : 'Ⅱ';
      }
      if (this.dataset.autoplay === 'true' && this.slides.length > 1 && !this.paused && !this.hovered && !document.hidden) {
        this.timer = setTimeout(() => this.show(this.index + 1), Math.max(3000, Number(this.dataset.interval) || 6000));
      }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.controller.abort(); }
  });
})();
